import { Container } from "inversify";
import { ContainerModules } from "@/arch/@core/main/ioc/ContainerModules";

const container = new Container();

container.load(...ContainerModules);

export { container };
